import React, { useEffect, useState } from "react";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";
import { GoPlus } from "react-icons/go";
import { Link } from "react-router-dom";
import AdminTicketModal from "./AdminTicketModal";
import LoadingSpan from "../../Component/Loading/LoadingSpan";
import { CiSearch } from "react-icons/ci";

export default function ContactAdmin() {
  const [loading, setLoading] = useState(false);
  const [loadingNewTicket, setLoadingNewTicket] = useState(false);
  const [chats, setChats] = useState([]);
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [newTicketSubject, setNewTicketSubject] = useState("");
  const [newTicketDescription, setNewTicketDescription] = useState("");
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchQuery(search);
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  const getAllChats = async () => {
    setLoading(true);

    try {
      const res = await apiRequests.get(
        "/tickets/v1/get-my-ticket-list-seller-admin",
        {
          params: {
            search: searchQuery,
          },
        },
      );

      const result = res.data;

      if (!result.data?.docs) {
        setChats([]);
        return;
      }

      setChats(result.data.docs);
    } catch (err) {
      console.log(err);

      setChats([]);

      toast.error(err.response?.data?.en_message || "Failed to get tickets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllChats();
  }, [searchQuery]);

  const submitNewTicket = async () => {
    const payload = {
      subject: newTicketSubject,
      description: newTicketDescription,
    };
    setLoadingNewTicket(true);
    try {
      const res = await apiRequests.post(
        "/tickets/v1/add-ticket-seller",
        payload,
      );
      toast.success(res.data.en_message);
      setNewTicketSubject("");
      setNewTicketDescription("");
      await getAllChats();
      setTicketModalOpen(false);
    } catch (err) {
      toast.error(err.data.en_message);
    } finally {
      setLoadingNewTicket(false);
    }
  };

  return (
    <>
      <div className="w-full px-10 flex gap-6 flex-col">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-semibold text-[#1f1b18]">
            Contact admin
          </h1>
          <div className="flex items-center gap-4">
            <div className="relative w-80">
              <CiSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by subject..."
                className="w-full h-11 pl-11 pr-4 rounded-xl border border-gray-200
                   bg-white text-sm text-gray-700 outline-none
                   focus:border-[#024E88]"
              />
            </div>
            <button
              className="bg-[#051F33] text-white px-5 py-2.5 rounded-2xl flex items-center gap-2 font-medium hover:bg-[#082a45] transition shadow-sm"
              onClick={() => setTicketModalOpen(true)}
            >
              <GoPlus className="text-xl" />
              Create new ticket
            </button>
          </div>
        </div>
        {loading ? (
          <div className="w-full h-64 flex items-center justify-center text-gray-500 font-medium gap-2">
            Loading tickets... <LoadingSpan />
          </div>
        ) : (
          <div className="w-full overflow-x-auto rounded-t-2xl">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gradient-to-r from-[#051F33] to-[#024E88] text-white">
                  <th className="p-4 font-medium capitalize pl-8">subject</th>
                  <th className="p-4 font-medium capitalize text-center">
                    status
                  </th>
                  <th className="p-4 font-medium capitalize text-center">
                    action
                  </th>
                </tr>
              </thead>
              <tbody>
                {chats.length > 0 ? (
                  chats.map((chat) => (
                    <tr
                      key={chat._id}
                      className="border-b border-[#AE9C91] hover:bg-gray-50 h-16 transition-colors"
                    >
                      <td className="p-4 pl-8 text-gray-600 font-medium">
                        {chat.subject}
                      </td>

                      <td className="p-4 text-center">
                        <span
                          className={`px-3 py-1 rounded-full text-sm font-medium ${
                            chat.status === "answered"
                              ? "bg-green-100 text-green-600"
                              : "bg-yellow-100 text-yellow-600"
                          }`}
                        >
                          {chat.status}
                        </span>
                      </td>

                      <td className="p-4 text-center">
                        <Link to={`/contactadmin/${chat._id}`}>
                          <button className="text-cyan-500 hover:text-cyan-700 font-medium text-sm">
                            see chat
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="p-10 text-center text-gray-500">
                      No tickets found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <AdminTicketModal
        isOpen={ticketModalOpen}
        onClose={() => setTicketModalOpen(false)}
      >
        <div>
          <div className="flex flex-col">
            <p className="font-bold text-xl pb-6">Send a new ticket to Admin</p>
            <div className="flex flex-col items-center gap-2 bg-[#efe5df] rounded-[30px] p-8 w-full shadow-sm">
              <div className="w-full">
                <input
                  type={"text"}
                  value={newTicketSubject}
                  onChange={(e) => setNewTicketSubject(e.target.value)}
                  placeholder={"subject"}
                  className="rounded-xl p-3 w-full outline-none"
                />
              </div>
              <div className="w-full">
                <textarea
                  value={newTicketDescription}
                  onChange={(e) => setNewTicketDescription(e.target.value)}
                  placeholder={"description"}
                  className="rounded-xl p-3 w-full resize-none h-48 outline-none"
                />
              </div>
              <div className="w-full flex justify-center">
                <button
                  onClick={submitNewTicket}
                  className="bg-[#051F33] text-white px-5 py-2.5 rounded-xl p-8 w-full shadow-sm"
                >
                  Send ticket
                </button>
              </div>
            </div>
          </div>
        </div>
      </AdminTicketModal>
    </>
  );
}
